import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

// Maison Luxe header — broker office plate. Brass-and-paper. NOT centered. Logo aligned left.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 border-b transition-all duration-500 ${scrolled ? 'bg-[#F4EFE5]/95 border-[#1F3A5F]/15 backdrop-blur-md py-3' : 'bg-[#F4EFE5] border-transparent py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[auto_1fr_auto] items-center gap-8">
        <button onClick={() => setPage('home')} data-testid="ml-logo" className="text-left">
          <p className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#1F3A5F]/55">— Est. {META.est}</p>
          <p className="font-serif italic text-[28px] leading-none text-[#1F3A5F]">{META.brand}</p>
        </button>
        <nav className="hidden md:flex items-center justify-center gap-10">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`ml-nav-${r.id}`} className={`font-mono text-[10px] tracking-[0.32em] uppercase transition-colors pb-1 ${page === r.id ? 'text-[#7B5527] border-b border-[#7B5527]' : 'text-[#1F3A5F]/65 hover:text-[#1F3A5F]'}`}>
              <span className="text-[#7B5527]">/</span> {r.label}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('viewing')} data-testid="ml-header-viewing" className="hidden md:inline-block font-mono text-[10px] tracking-[0.32em] uppercase border border-[#1F3A5F] text-[#1F3A5F] px-5 py-2.5 hover:bg-[#1F3A5F] hover:text-[#F4EFE5] transition-colors">Viewing →</button>
      </div>
    </header>
  );
}
